import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

require('moment/locale/es')

Vue.use(VueMoment, {
    moment
})

Vue.filter('initialName', function (value) {
    if (value === undefined) return
    return value.charAt(0).toUpperCase()
})

Vue.filter('filenameFromUrl', function (value) {
    if (value === undefined) return
    return value.substring(value.lastIndexOf('/') + 1)
})

Vue.filter('stringToSlug', function (str) {
    str = str.replace(/^\s+|\s+$/g, '') // trim
    str = str.toLowerCase()
    // remove accents, swap ñ for n, etc
    var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
    var to = 'aaaaeeeeiiiioooouuuunc------'
    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
    }
    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes
    return str
})

Vue.filter('camelCaseWithSpace', function (str) {
    return (str || '')
        .replace(/([a-z])/g, ' $1')
        .replace(/^./, function (str) {
            return str.toUpperCase()
        })
})

Vue.filter('momentFormatDate', function (value, format) {
    if (value === undefined) return '--/--/----'
    return Vue.moment(value.iso).format(format)
})

Vue.filter('momentFormatDateNoISO', function (value, format) {
    if (value === undefined) return '--/--/----'
    return Vue.moment(value).format(format)
})

Vue.filter('momentFormatDateTZ', function (value, tz, format) {
    if (value === undefined) return '--/--/----'
    return Vue.moment(value.iso).tz(tz).format(format)
})

Vue.filter('moment', function (value, tz, format) {
    return Vue.moment(value).tz(tz).format(format)
})

Vue.filter('momentUTC', function (value, tz, format) {
    return Vue.moment(value).tz(tz).utc().format(format)
})

Vue.filter('additiveStatusString', function (value) {
    const locale = localStorage.getItem('locale') || 'pt-BR'
    if (value === undefined) {
        const unknownStatusMessages = {
            'pt-BR': 'Status desconhecido',
            'en-US': 'Unknown status',
            'es-ES': 'Estado desconocido'
        }
        return unknownStatusMessages[locale] || unknownStatusMessages['pt-BR']
    }
    const statusMessages = {
        'pt-BR': {
            1: 'Pendente',
            2: 'Assinado',
            3: 'Cancelado'
        },
        'en-US': {
            1: 'Pending',
            2: 'Signed',
            3: 'Cancelled'
        },
        'es-ES': {
            1: 'Pendiente',
            2: 'Firmado',
            3: 'Cancelado'
        }
    }
    return statusMessages[locale]?.[value] || statusMessages['pt-BR'][value]
})
